import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import styles from '@components/PromotionalMessages/PromotionalMessages.styles';
import Icon from '@components/icons/Icon';
import CmsPromotionalMessage from '@features/cms/objects/CmsPromotionalMessage';
import { TIcon } from '@components/icons/typescript';
import theme from '@styles/theme';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
export type PropsType = {
  isActive: boolean;
  messages: CmsPromotionalMessage[];
};
const PromotionalMessages = ({
  isActive,
  messages
}: PropsType) => {
  const {
    barPositionStatic
  } = layoutUiState;
  const renderMessage = (message: CmsPromotionalMessage) => {
    let result = <div sx={styles.containerWrapper} data-testid="promotionalMessage">
        {message.text}
      </div>;
    if (message.hasLink() && message.hasIcon()) {
      result = <Link href={message.getPrepareLink() as string} data-testid="promotionalMessage">
          <Icon icon={message.getIconType() as TIcon} size="16px" color={theme.rawColors.neutralWhite} />
          <span>{message.getText()}</span>
        </Link>;
    } else if (message.hasLink()) {
      result = <Link href={message.getPrepareLink() as string} data-testid="promotionalMessage">
          <span>{message.text}</span>
        </Link>;
    } else if (message.hasIcon()) {
      result = <div sx={styles.containerWrapper} data-testid="promotionalMessage">
          <Icon icon={message.getIconType() as TIcon} size="16px" color={theme.rawColors.neutralWhite} />
          {message.text}
        </div>;
    }
    return result;
  };
  return <>
      <div sx={styles.container(isActive, barPositionStatic)} data-testid="promotionalMessages">
        {isActive && messages.map((message, index) => <div key={message.getText()} sx={index > 0 ? styles.desktopOnly : undefined}>
              {renderMessage(message)}
            </div>)}
      </div>
    </>;
};
export default observer(PromotionalMessages);